export default __webpack_public_path__ + "static/media/guranteed-icon.54f32f57.svg";